import {
  Component,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  Inject,
  NgZone,
  HostListener,
  ViewChild
} from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from '../utility/local-storage.service';
import { Router } from '@angular/router';
import * as Noty from 'noty';
import { PivcApiServices } from '../services/pivc-api.service';
import * as globals from '../utility/global';
import * as vrModel from './video-recording.model';
import { CommonService } from '../utility/common.service';
import * as AWS from 'aws-sdk';
import { utilityConfig } from '../utility/app-config';
import { interval, Subscription } from 'rxjs';
declare var faceapi: any;

const CHROME_LANG = {
  ENGLISH: 'en-US',
  HINDI: 'hi-IN',
};

const FIREFOX_LANG = {
  ENGLISH: 'en-US',
  HINDI: 'hi',
};
@Component({
  selector: 'app-video-recording',
  templateUrl: './video-recording.component.html',
  styleUrls: ['./video-recording.component.scss']
})
export class VideoRecordingComponent implements OnInit {

  @ViewChild("video", { static: false }) video: ElementRef;
  ngVersion: string;
  streaming = false;
  error: any;

  private stream: MediaStream = null;
  private aStream: MediaStream = null;
  private constraints = {
    audio: false,
    video: true,
  };
  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  private ctx: CanvasRenderingContext2D;
  public audioPolly: HTMLAudioElement;
  // public video: HTMLVideoElement;
  public localStream;
  public mediaRecorder;
  //public mediaSource = new MediaSource();
  public chunks = [];
  public gumVideo: any;
  public questionList: any = [];
  public index: number;
  public questionListLength: number;
  public answers: any = [];
  public recordingFlag = false;
  public interval: any;
  public timeLeft: number = globals.TIMER_LEFT;
  // public stream: MediaStream;
  public notify: any;
  public ipAddress: any;
  public voices: any;
  public options: {
    mimeType: string;
    audioBitsPerSecond: number;
    videoBitsPerSecond: number;
  };
  public notificationFlag = false;
  public questionListStorage: any = LocalStorageService.get('questionsList')
    ? LocalStorageService.get('questionsList')
    : '';
  public answerList = LocalStorageService.get('answerList')
    ? LocalStorageService.get('answerList')
    : '';
  public contentDetails: any | object = LocalStorageService.get(
    'contentDetails'
  )
    ? LocalStorageService.get('contentDetails')
    : '';

  // For browser details and video flag
  public logData: any = LocalStorageService.get('logData') ? LocalStorageService.get('logData') : '';
  public vidFlag: any = LocalStorageService.get('vidFlag') ? LocalStorageService.get('vidFlag') : '';
  public errorLog: string[] = LocalStorageService.get('errorLog') ? LocalStorageService.get('errorLog') : [];

  private nextQuestionFlag = false;
  private utterance: SpeechSynthesisUtterance;
  policyHolderName;
  public byteString: any;
  public dbImageId: any;
  public currentImageId: any;
  public dataArray = [];
  public base64video: any;
  public enableButton = false;
  public captureFlag = false;
  public questionSubmitBtn: boolean;
  public locationData: any = LocalStorageService.get('locationData') ? LocalStorageService.get('locationData') : '';
  public pivcUrl: any = LocalStorageService.get('url') ? LocalStorageService.get('url') : '';
  sub: Subscription;
  answer: String = "";
  private alive = true;
  isSafari = true;
  constructor(
    private https: HttpClient,
    private http: HttpClient,
    private location: Location,
    @Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef,
    private el: ElementRef,
    public router: Router,
    private serviceRest: PivcApiServices,
    private zone: NgZone,
    public common: CommonService,

  ) { }
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    speechSynthesis.cancel();
  }
  /*
   * Initial LifeCycleHook
   */
  async ngOnInit() {

    this.getIPAddress();
    this.getBrowserDetails();
    this.policyHolderName = this.common.ucFirst(this.contentDetails.LA_Name)
    // this.serviceRest.showAjaxLoader();
    // this.mediaSource.addEventListener(
    //   'sourceopen',
    //   this.handleSourceOpen,
    //   false
    // );
    if (
      typeof this.contentDetails !== 'object' &&
      Object.keys(this.contentDetails).length === 0 || this.questionListStorage.length === 0
    ) {
      this.router.navigate(['/']);
    } else {
      //await faceapi.loadSsdMobilenetv1Model('./assets/models');
      await faceapi.loadTinyFaceDetectorModel('../assets/models');
      faceapi.env.monkeyPatch({
        Canvas: HTMLCanvasElement,
        Image: HTMLImageElement,
        ImageData: ImageData,
        Video: HTMLVideoElement,
        createCanvasElement: () => document.createElement('canvas'),
        createImageElement: () => document.createElement('img')
      });

      await this.getStream();
      this.questionListing();
      history.pushState(null, null, location.href);
      window.onpopstate = () => history.go(1);
    }
  }

  ngAfterViewInit() {
    this.ctx = this.canvas.nativeElement.getContext('2d');
  }

  /**
   * @name getStream
   * @description Permission to use device video and audio input
   * @returns Media Stream from device
   */
  getStream() {
    // const constraints = {
    //   audio: {
    //     echoCancellation: { exact: true },
    //     sampleRate: 48000,
    //     volume: 1.0
    //   },
    //   video: { facingMode: 'user' }
    // };
    // navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia ||
    //   navigator.mozGetUserMedia || navigator.msGetUserMedia;
    // try {
    //   this.stream = await navigator.mediaDevices.getUserMedia(constraints);
    //   this.handleSuccess(this.stream);
    // } catch (e) {
    //   const apiNotify = new Noty({
    //     text: 'Unable to access front camera',
    //     theme: 'mint',
    //     type: 'info',
    //     timeout: 5000
    //   });
    //   apiNotify.show();
    //   //this.router.navigate(['/language']);
    //   window.open(this.pivcUrl, "_self");
    //   console.error('navigator.getUserMedia error:', e);
    // }

    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia || navigator.msGetUserMedia;
    this.getMediaStream()
      .then((stream) => {
        this.stream = stream;
        this.streaming = true;
        this.handleSuccess(this.stream);
      })
      .catch((err) => {
        this.gotoTop();
        const apiNotify = new Noty({
          text: 'Unable to access front camera',
          theme: 'mint',
          type: 'info',
          timeout: 5000,
          layout: 'bottomCenter'
        });
        apiNotify.show();
        //this.router.navigate(['/language']);
        alert("Error 3. " + err);
        window.open(this.pivcUrl, "_self");

        console.error('navigator.getUserMedia error:', err);
      });
  }

  /**
   * @name handleSuccess
   * @param stream
   * @description display media stream in the screen
   */

  async handleSuccess(stream) {
    window.stream = stream;
    const constraints = {
      audio: {
        echoCancellation: { exact: true },
        sampleRate: 48000,
        volume: 1.0
      }
    };
    try {
      this.aStream = await navigator.mediaDevices.getUserMedia(constraints);
      this.startRecording();
    } catch (error) {
      this.gotoTop();
      const apiNotify = new Noty({
        text: 'Unable to start recording',
        theme: 'mint',
        type: 'info',
        timeout: 5000,
        layout: 'bottomCenter'
      });
      apiNotify.show();
      //this.router.navigate(['/language']);
      alert("Error 1. " + error)
      window.open(this.pivcUrl, "_self");
      console.error('navigator.getUserMedia error:', error);
    }

  }

  /**
   * @name handleSourceOpen
   * @description Adds new SourceBuffer to Media Source with given MIME type
   */

  /**
   * @name startRecording
   * @param stream // Meadia Stream
   * @description starts capturing the streaming video; MediaRecorder API
   */

  async startRecording() {
    this.options = {
      mimeType: 'video/webm;codecs=vp9',
      audioBitsPerSecond: 128000,
      videoBitsPerSecond: 300000
    };
    try {
      if (!MediaRecorder.isTypeSupported(this.options.mimeType)) {
        console.error(`${this.options.mimeType} is not Supported`);
        this.options.mimeType = 'video/webm: codecs=vp8';
        if (!MediaRecorder.isTypeSupported(this.options.mimeType)) {
          console.error(`${this.options.mimeType} is not Supported`);
          this.options.mimeType = 'video/webm';
          if (!MediaRecorder.isTypeSupported(this.options.mimeType)) {
            console.error(`${this.options.mimeType} is not Supported`);
            this.options.mimeType = '';
          }
        }
      }
    } catch (e) {
      alert("Error 2. " + e)
    }


    this.stream = (this.canvas.nativeElement as any).captureStream();
    this.stream.addTrack(this.aStream.getAudioTracks()[0]);

    var mixedStream = 'MediaStream' in window ? new MediaStream([this.stream.getVideoTracks()[0], this.aStream.getAudioTracks()[0]]) : this.stream;

    this.mediaRecorder = new MediaRecorder(mixedStream, this.options);
    this.mediaRecorder.onstop = event => {
    };
    this.mediaRecorder.ondataavailable = event => {
      if (event.data && event.data.size > 0) {
        this.chunks.push(event.data);
      }
    };
    this.mediaRecorder.start(10);

    // setTimeout(() => {
    //   this.screenCapture();
    // }, 7000);
  }

  /**
   * @name screenCapture
   * @param stream // Media Stream
   * @description takes a screen shot of the video frame; ImageCapture API
   */

  async screenCapture() {
    const canvasVideo = document.createElement('canvas') as HTMLCanvasElement;
    const contextCanvas = canvasVideo.getContext('2d');
    const vid = document.querySelectorAll('video');
    const w = vid[0].videoWidth;
    const h = vid[0].videoHeight;
    canvasVideo.height = h;
    canvasVideo.width = w;
    contextCanvas.fillRect(0, 0, w, h);
    contextCanvas.drawImage(vid[0], 0, 0, w, h);
    const url = canvasVideo.toDataURL();
    LocalStorageService.set('userScreenshot', url);
    this.captureFlag = true;
    // console.log("Screen capture!!");
  }

  /**
   * @name stopRecording
   * @description Stops the recording of the media stream
   */
  stopRecording() {
    this.mediaRecorder.stop();
    this.stream.getTracks().forEach(track => {
      track.stop();
    });

    this.aStream.getTracks().forEach(track => {
      track.stop();
    });
    this.alive = false;
    this.audioPolly.pause();
    this.captureFlag = false;
  }
  /**
   * @name playRecording
   * @description creates a blob of the recorded video, which is then
   *              converted to a URL and embedded into the HTML <video> tag for preview
   */
  playRecording() {
    const superBuffer = new Blob(this.chunks, { type: this.options.mimeType });
    this.gumVideo.src = null;
    this.gumVideo.srcObject = null;
    this.gumVideo.src = window.URL.createObjectURL(superBuffer);
    this.gumVideo.controls = true;
    const reader = new FileReader();
    reader.readAsDataURL(superBuffer);
    reader.onloadend = () => {
      this.base64video = reader.result;
    };
  }

  /**
   * @name questionListing
   * @description gets question listing from LocalStorage
   */
  async questionListing() {
    this.questionList = Object.values(this.questionListStorage);
    document.getElementById(
      'question'
    ).innerHTML = this.questionList[0].question;
    let lang;
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      lang = FIREFOX_LANG[this.questionList[4]];
    } else {
      lang = CHROME_LANG[this.questionList[4]];
    }
    this.getVoiceData().then((res) => {
      this.voices = res.filter((voicesArr) => voicesArr.lang === lang)[0];

      setTimeout(() => {
        const input = document.getElementById('canvas');
        this.faceDetection(input, this.questionList[0].nativeQuestion);
      }, 4000);
      // 
      // this.notifyTimer();
      // this.enableButton = true;
      // 
      this.questionListLength = Object.keys(this.questionListStorage).length - 2;
      this.index = 0;
    });
  }

  /**
   * @name nextQuestion
   * @param answer
   * @description Displays the next question when user selects their answer
   */
  nextQuestion(answer) {
    this.answer = answer == 'Y' ? 'Yes' : 'No';
    this.enableButton = false;
    this.questionSubmitBtn = true;
    document.getElementById('circle').removeAttribute('class');
    if (this.notificationFlag) {
      this.notify.close();
    }
    this.recordingFlag = false;
    this.audioPolly.pause();
    clearInterval(this.interval);
    this.saveAnswer(answer);
    this.questionSubmitBtn = false;

    setTimeout(() => {
      if (this.index === this.questionListLength - 1) {
        LocalStorageService.set('answerList', this.answers);
        this.stopRecording();
        setTimeout(() => {
          document.getElementById('question').innerHTML = '';
          this.answer = '';
          this.recordingFlag = true;
          this.changeDetectorRef.detectChanges();
          this.gumVideo = this.el.nativeElement.querySelector(
            '#recorded'
          ) as ElementRef;
          this.playRecording();
        }, 2500);
      }
      this.timeLeft = globals.TIMER_LEFT;
      while (this.index < this.questionListLength - 1) {
        this.index++;
        document.getElementById('question').innerHTML = this.questionList[
          this.index
        ].question;
        this.answer = '';
        const input = document.getElementById('canvas');
        this.faceDetection(input, this.questionList[this.index].nativeQuestion);
        // 
        // this.notifyTimer();
        // this.enableButton = true;
        // 
        break;
      }
    }, 1500);
  }
  /**
   * @name saveAnswer
   * @param answer
   * @description Saves the answers recorded by the user
   */
  saveAnswer(answer) {
    this.answers.push({
      PIVC_QID: this.questionList[this.index].PIVCQID,
      Answer: answer
    });
  }
  /**
   * @name restartVideo
   * @description to restart the entire journey of video recording
   */
  restartVideo() {
    speechSynthesis.cancel();
    location.reload();
  }

  /**
   * @name getVoiceData
   * @description promise to get voices for speech synthesis
   */
  getVoiceData(): Promise<any> {
    return new Promise((resolve, reject) => {
      let voices = speechSynthesis.getVoices();
      if (voices.length > 0) {
        resolve(voices);
        return;
      }
      speechSynthesis.onvoiceschanged = () => {
        voices = speechSynthesis.getVoices();
        resolve(voices);
      };
    });
  }

  pollyTextToSpeech(text) {
    var timeOffset = localStorage.getItem("TimeOffset");
    
    AWS.config.region = 'ap-south-1';

    AWS.config.correctClockSkew = true;
    AWS.config.systemClockOffset = +timeOffset;

    AWS.config.credentials = new AWS.CognitoIdentityCredentials({ IdentityPoolId: 'ap-south-1:5ce358d2-aff4-49b0-83c2-66362cb34de3' });
    let polly = new AWS.Polly({ apiVersion: '2016-06-10' });
    var options = {
      speechParams: {
        OutputFormat: "mp3",
        SampleRate: "16000",
        Text: text,
        TextType: "text",
        VoiceId: "Raveena"
      },
      polly
    };
    this.audioPolly = new Audio();
    this.audioPolly.onended = (event) => {
      this.notifyTimer();
      this.enableButton = true;
    }
    var signer = new AWS.Polly.Presigner(options as AWS.Polly.Presigner.PresignerOptions)
    signer.getSynthesizeSpeechUrl(options.speechParams, (error, url) => {
      if (error) {
        console.log(error);
        // document.getElementById('result').innerHTML = error;/

      } else {
        console.log("Audio=======", url);
        document.getElementById('audioSource').setAttribute('src', url);
        this.audioPolly.src = url;
        this.audioPolly.load();
        this.audioPolly.play();
        // audioPlayback.play();
      }
    });
  }

  /**
   * @name questionToSpeech
   * @param text
   * @description set the configuration for the voice for Text to speech; start speech.
   */
  // questionToSpeech(text) {
  //   this.serviceRest.hideAjaxLoader();
  //   const utterance = new SpeechSynthesisUtterance();
  //   utterance.voice = this.voices;
  //   utterance.text = text;
  //   utterance.rate = 0.8;
  //   utterance.pitch = 1;
  //   utterance.volume = 1;
  //   setTimeout(() => {
  //     speechSynthesis.speak(utterance);
  //   }, 0);
  //   utterance.onend = () => {
  //     if (!this.nextQuestionFlag) {
  //       this.notifyTimer();
  //     }
  //     this.nextQuestionFlag = false;
  //   };
  //   let timer = setTimeout(function pauseResumeTimer() {
  //     speechSynthesis.pause();
  //     setTimeout(() => {
  //       speechSynthesis.resume();
  //     }, 0);

  //     timer = setTimeout(pauseResumeTimer, 10000);
  //   }, 10000);
  // }
  /**
   * @name notifyTimer
   * @description pop up notification for idle user
   */
  notifyTimer() {
    this.gotoTop();
    this.notify = new Noty({
      text: 'Please select an option.',
      theme: 'mint',
      type: 'info',
      closeWith: ['click', 'button'],
      layout: 'bottomCenter'
    });
    this.timeLeft = globals.TIMER_LEFT;
    this.interval = setInterval(() => {

      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
        if (this.timeLeft === (globals.TIMER_LEFT / 2)) {
          this.notificationFlag = true;
          this.notify.show();
        }
        if (this.timeLeft < 10 && !this.recordingFlag) {
          this.runTimerAnimation();
          this.timeLeft++;
        } else if (this.recordingFlag) {
          clearInterval(this.interval);
        } else {
          clearInterval(this.interval);
          this.notify.close();
          this.stopRecording();
          this.zone.run(() => {
            //this.router.navigate(['/language']);
            window.open(this.pivcUrl, "_self");
          });
        }
      }
    }, 1000);
  }

  /*
   * Convert Data URI to File
   */
  dataURItoBlob(dataURI) {
    let mimeString = utilityConfig.mimeString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      this.byteString = atob(dataURI.split(',')[1]);
      mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
    } else {
      this.byteString = atob(dataURI);
    }
    const ia = new Uint8Array(this.byteString.length);
    for (let i = 0; i < this.byteString.length; i++) {
      ia[i] = this.byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }

  /**
   * @name submit
   * @param flag
   * @description After preview, final updated answers are submitted.
   */

  submit(flag: string) {
    if (flag === 'submit') {
      this.updatePIVCQuestionAns();
    } else {
      ////this.router.navigate(['/language']);
      this.notify.close();
      this.zone.run(() => {
        //this.router.navigate(['/language']);
        window.open(this.pivcUrl, "_self");
      });
    }
  }

  /*
   * Method calls the API to update the PIVC Questions and Answers
   */
  updatePIVCQuestionAns() {
    const apiData = {
      Login_Code: utilityConfig.loginCode,
      PIVC_ID: this.contentDetails.PIVC_ID,
      policyNumber: this.contentDetails.policyNumber,
      lstPIVCQuestionAns: this.answerList
    };
    this.serviceRest
      .updatePIVCQuestionAns(utilityConfig.updatePIVCQuestionAns, apiData)
      .subscribe(
        (data: vrModel.updatePIVCQuestionAnsApi) => {
          // this.getPhotoPIVCVerfication();
          this.dmsupload();
        },
        error => {
          const errorMessage = this.errorSplit(error);
          const apiNotify = new Noty({
            text: errorMessage,
            theme: 'mint',
            type: 'info',
            timeout: 5000,
            layout: 'bottomCenter'
          });
          apiNotify.show();
          this.serviceRest.hideAjaxLoader();
        }
      );
  }

  /*
   * getPhotoPIVCVerfication
   */
  getPhotoPIVCVerfication() {
    const apiData = {
      LoginCode: utilityConfig.loginCode,
      PIVC_ID: this.contentDetails.PIVC_ID,
      policyNumber: this.contentDetails.policyNumber,
    };
    this.serviceRest
      .getPhotoPIVCVerfication(utilityConfig.getPhotoPIVCVerfication, apiData)
      .subscribe(
        (data: vrModel.getPhotoPIVCVerficationApi) => {
          this.faceComapareApi(data.DataImg);
        },
        error => {
          const errorMessage = this.errorSplit(error);
          const apiNotify = new Noty({
            text: errorMessage,
            theme: 'mint',
            type: 'info',
            timeout: 5000,
            layout: 'bottomCenter'
          });
          apiNotify.show();
          this.serviceRest.hideAjaxLoader();
        }
      );
  }

  /*
   *faceCompare API
   */
  faceComapareApi(dbStoredImage) {
    const dbImage = this.dataURItoBlob(utilityConfig.dbImage);
    const currentImage = this.dataURItoBlob(dbStoredImage);
    const fileArray = {
      dbImage: URL.createObjectURL(dbImage),
      currentImage: URL.createObjectURL(currentImage)
    };
    // const [face1, face2] = [this.dataArray[0], this.dataArray[1]];

    const formData = new FormData();
    formData.append('face_image_1', dbImage, 'abc.jpeg');
    formData.append('face_image_2', currentImage, 'bcd.jpeg');

    this.serviceRest.faceComapareApi(utilityConfig.faceCompareUri, formData).subscribe(
      response => {
        this.dmsupload();
      },
      error => {
        this.gotoTop();
        const errorMessage = this.errorSplit(error);
        const apiNotify = new Noty({
          text: errorMessage,
          theme: 'mint',
          type: 'info',
          timeout: 5000,
          layout: 'bottomCenter'
        });
        apiNotify.show();
        this.serviceRest.hideAjaxLoader();
      }
    );
  }

  /*
   * DMSUpload
   */
  dmsupload() {
    const base64RecordedVideo = this.base64video.split('base64,');
    this.contentDetails.LA_Name = this.contentDetails.LA_Name.replace(' ', '_');
    this.vidFlag = LocalStorageService.get('vidFlag');

    if (base64RecordedVideo[1] && typeof base64RecordedVideo[1] !== 'undefined') {
      this.resetVidFlag();
      //  API changed by client

      // const apiData = {
      //   appId: this.contentDetails.policyNumber,
      //   reqRaisedAt: 'STP',
      //   reqCd: 'ME120',
      //   reqSeq: 42951,
      //   createdBy: 14,
      //   documentComment: 'documentComment',
      //   fileName: `${this.contentDetails.policyNumber}_${this.contentDetails.LA_Name}_test2.mp4`,
      //   iibparms: 'dmsDocUpload',
      //   sourceSystem: 'PORTAL',
      //   targetSystem: 'DMS',
      //   creationDtTm: '2017-05-19-19.55.43.000000',
      //   uniqueRef: 'uniqueRef',
      //   fileData: base64RecordedVideo[1],
      //   documentType: 'PIVC'
      // };
      const apiData = {
        PIVC_ID: this.contentDetails.PIVC_ID,
        PolicyNumber: this.contentDetails.policyNumber,
        LoginCode: utilityConfig.loginCode,
        PIVCVideo: base64RecordedVideo[1],
        SourceFrom: 'PRGAPP',
        IPAddress: this.ipAddress,
        DeviceID: '1234rd',
        AppVersion: 12.3,
        OSType: 'Android',
      };
      this.serviceRest.dmsUpload(utilityConfig.dmsupload, apiData).subscribe(
        data => {
          this.updatePIVCFinalStatus();
        },
        error => {
          const errorMessage = this.errorSplit(error);
          const apiNotify = new Noty({
            text: errorMessage,
            theme: 'mint',
            type: 'info',
            timeout: 5000,
            layout: 'bottomCenter'
          });
          apiNotify.show();
          this.serviceRest.hideAjaxLoader();
        }
      );
    } else {

      let text = "";
      if (this.vidFlag === "") {
        text = "Unable to upload video. Please restart Video.";
        this.setVidFlag();
      } else {
        text = "Video not uploaded. Please contact to customer support executive.";
        this.setVidFlag();
      }
      const apiNotify = new Noty({
        text: text,
        theme: 'mint',
        type: 'info',
        timeout: 5000,
        layout: 'bottomCenter'
      });
      apiNotify.show();
      this.serviceRest.hideAjaxLoader();
    }
  }

  /*
   * Completion of PIVC
   */
  updatePIVCFinalStatus() {
    const capturedImage = this.userCurrentImageBase64();

    this.logData = LocalStorageService.get("logData");
    this.errorLog = LocalStorageService.get("errorLog");

    const apiData = {
      LoginCode: utilityConfig.loginCode,
      PIVC_ID: this.contentDetails.PIVC_ID,
      PhotoVerified: 'Y',
      PIVC_Status: 'Success',
      SourceFrom: 'PRGAPP',
      PIVCVideoURL: '',
      PIVC_Completion_PDF: '',
      VerificationFailedReason: '',
      PIVC_RefID: '',
      PIVC_PhotoVerified_With: capturedImage,
      PIVC_Completion_Latitude: this.locationData !== '' ? this.locationData.latitude : '',
      PIVC_Completion_Longitude: this.locationData !== '' ? this.locationData.longitude : '',
      PIVC_Completion_Address: this.contentDetails.LA_Address,
      Browser_Name: this.logData.Browser_Name,
      Browser_Version: this.logData.Browser_Version,
      Browser_Error: this.errorLog,
      Browser_Platform: this.logData.Browser_Platform,
      AddInput1: this.logData.AddInput1,
      AddInput2: this.logData.AddInput2,
    };
    this.serviceRest
      .updatePIVCFinalStatus(utilityConfig.updatePIVCFinalStatus, apiData)
      .subscribe(
        (data: vrModel.updatePIVCFinalStatusApi) => {
          if (data.ReverseURL) {
            window.location.href = data.ReverseURL;
          } else {
            this.router.navigate(['/pivc-complete']);
          }

        },
        error => {
          const errorMessage = this.errorSplit(error);
          const apiNotify = new Noty({
            text: errorMessage,
            theme: 'mint',
            type: 'info',
            timeout: 5000,
            layout: 'bottomCenter'
          });
          apiNotify.show();
          this.serviceRest.hideAjaxLoader();
        }
      );
  }

  /*
   * Lifecycle Hook
   */
  ngDoCheck(): void {
    this.answerList = LocalStorageService.get('answerList')
      ? LocalStorageService.get('answerList')
      : '';
  }

  /*
   * Split the Secret Error code and split the message
   */
  errorSplit(error) {
    if (error.indexOf('UA') !== -1 || error.indexOf('UM') !== -1) {
      const errorSplit = error.split(':');
      return errorSplit[1].trim();
    } else {
      return error;
    }
  }

  runTimerAnimation() {
    let countdown = globals.TIMER_LEFT;
    document.getElementById('circle').setAttribute('class', 'active-circle');

    const timerInterval = setInterval(() => {
      if (countdown === 10) {
        clearInterval(timerInterval);
      } else {
        countdown = ++countdown <= 10 ? globals.TIMER_LEFT : countdown;
      }
    }, 1000);
  }

  /*
   * Code to get the base64 code of captured image
  */
  userCurrentImageBase64() {
    if (LocalStorageService.get('userScreenshot') && LocalStorageService.get('userScreenshot') !== '') {
      const base64Code = LocalStorageService.get('userScreenshot').split('base64,');
      return base64Code[1];
    } else {
      throw new Error(`Didn't captured the Image`);
    }
  }

  /**
   * Getting Client's IP Address
   */
  getIPAddress() {
    this.https.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  // Face detection
  faceDetection = async (input, text) => {
    if (this.notify)
      this.notify.close();
    const detections = await faceapi.detectSingleFace(input, new faceapi.TinyFaceDetectorOptions());
    // console.log("detectFace-->", detections)
    this.alive = false;
    if (!detections || detections == undefined) {
      this.alive = true;
      this.gotoTop();
      this.notify = new Noty({
        text: 'Face not detected.',
        theme: 'mint',
        type: 'info',
        closeWith: ['click', 'button'],
        layout: 'bottomCenter'
      });
      this.notify.show();
      setTimeout(() => {
        this.faceDetection(input, text)
      }, 5000);
    } else {
      this.pollyTextToSpeech(text);
      if (!this.captureFlag)
        this.screenCapture();
    }
  }

  // detectFace(data_uri) {
  //   AWS.config.region = 'ap-south-1';
  //   AWS.config.credentials = new AWS.CognitoIdentityCredentials({ IdentityPoolId: 'ap-south-1:5ce358d2-aff4-49b0-83c2-66362cb34de3' });
  //   let rekognition = new AWS.Rekognition();
  //   let detectFace = rekognition.detectFaces(
  //     {
  //       Attributes: ["ALL", "DEFAULT"],
  //       Image: {
  //         // Bytes: this.b64toBlob(data_uri),
  //         Bytes: data_uri,
  //         // S3Object: {
  //         //   Bucket: bucket,
  //         //   Name: name
  //         // }
  //       }
  //     }
  //   ).promise();

  //   return detectFace
  //     .then((data) => {
  //       console.log("data--->>", data);
  //       return data.FaceDetails[0] ? true : false;
  //     }).catch((e) => {
  //       console.log("data--->>", e);
  //       return false;
  //     });
  // }

  private getMediaStream(): Promise<MediaStream> {
    const video_constraints = {
      audio: {
        echoCancellation: { exact: true },
        sampleRate: 48000,
        volume: 1.0
      },
      video: { facingMode: 'user' }
    };
    this.video.nativeElement.muted = true;
    //const video_constraints = { video: true };
    const _video = this.video.nativeElement;
    const _canvas = this.canvas.nativeElement;
    const _ctx = this.ctx;
    return new Promise<MediaStream>((resolve, reject) => {
      // (get the stream)
      return navigator.mediaDevices.
        getUserMedia(video_constraints)
        .then(stream => {
          (<any>window).stream = stream; // make variable available to browser console
          _video.srcObject = stream;
          // _video.src = window.URL.createObjectURL(stream);
          _video.onloadedmetadata = function (e: any) {
            _canvas.width = _video.videoWidth;
            _canvas.height = _video.videoHeight;

            var $this = this; //cache
            (function loop() {
              if (!$this.paused && !$this.ended) {
                _ctx.drawImage($this, 0, 0);

                _ctx.fillStyle = "black";
                _ctx.globalAlpha = 0.4;
                _ctx.fillRect(0, _canvas.height - 40, _canvas.width, 40);
                _ctx.globalAlpha = 1.0;
                //ctx.globalAlpha = 0.2;
                _ctx.font = '12pt Calibri';
                _ctx.fillStyle = 'white';
                _ctx.fillText(document.getElementById('question').innerHTML.replace(/<[^>]*>/g, ''), 5, _canvas.height - 25, _canvas.width - 10);
                _ctx.fillText("Selected Option - " + document.getElementById('answer').innerHTML.replace(/<[^>]*>/g, ''), 5, _canvas.height - 10, _canvas.width - 10);
                setTimeout(loop, 1000 / 30); // drawing at 30fps
              }
            })();
          };
          _video.play();
          return resolve(stream);
        })
        .catch(err => reject(err));
    });
  }

  // Capture Browser details
  getBrowserDetails() {
    if (!this.logData) {
      let userAgent = this.common.getBrowserUserAgent();
      const browserData = {
        Browser_Name: this.common.myBrowser(),
        Browser_Version: this.common.getBrowserVersion(),
        Browser_Error: '',
        Browser_Platform: userAgent.platform,
        AddInput1: userAgent,
        AddInput2: '',
      }
      LocalStorageService.set('logData', browserData);

    }
  }

  setVidFlag() {
    this.vidFlag = "101";
    LocalStorageService.set('vidFlag', "101");
  }

  resetVidFlag() {
    this.vidFlag = "";
    LocalStorageService.set('vidFlag', "");
  }


  gotoTop() {
    window.scroll({ 
      top: 300, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

}